module.exports = __webpack_public_path__ + "5adf6c7f6a52cc54e833c1ca0d4ba86b.svg";